// shared/ui/SectionCard.jsx  (tarjeta blanca con título, subtítulo y acciones a la derecha)
import React from 'react';
import CardContainer from '../../../../components/card/card-container.jsx';

const SectionCard = ({ title, subtitle, actions, children }) => (
  <CardContainer style={{ marginBottom: 20 }}>
    {(title || actions) && (
      <div className="d-flex justify-content-between align-items-start flex-wrap mb-3" style={{ gap: 12 }}>
        <div>
          {title && <h4 style={{ marginBottom: 2 }}>{title}</h4>}
          {subtitle && <div style={{ color: '#6c757d' }}>{subtitle}</div>}
        </div>
        {actions && (
          <div className="d-flex align-items-center flex-wrap" style={{ gap: 10 }}>
            {actions}
          </div>
        )}
      </div>
    )}
    {children}
  </CardContainer>
);

export default SectionCard;
